import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostBinding, HostListener, Input, NgZone, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularResizeElementDirection, AngularResizeElementEvent } from 'angular-resize-element';
import _ from 'lodash';
import moment from 'moment';
import { Subject, Subscription, debounceTime } from 'rxjs';
import { DashboardService } from 'src/app/services/dashboard.service';
import { FilterService } from 'src/app/services/filter.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { ExpandThreadComponent } from './expand-thread.component';
import { EnhancementService } from 'src/app/services/enhancements-service';
import { CommentsNotesService } from './comments-notes.service';
import { DialogService } from 'src/app/services/dialog.service';
import { PopupDeleteComponent } from '../popup-delete/popup-delete.component';
import { DatePipe } from '@angular/common';
import { HashtagService } from './hashtag.service';

@Component({
  selector: 'app-comments-notes',
  templateUrl: './comments-notes.component.html',
  styleUrls: ['./comments-notes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommentsNotesComponent implements OnInit {

  @Input("offcanvasRightAnnotationNotes") offcanvasRightAnnotationNotes:any;
  @Input("annotationIndication") annotationIndication:any;
  @Input("notesConfiguration") notesConfiguration:any;

  @Output("onResizeSideWindow") onResizeSideWindow = new EventEmitter<any>();
  public readonly AngularResizeElementDirection = AngularResizeElementDirection;
  public onResizeSide(evt: AngularResizeElementEvent): void {
    this.data.width = evt.currentWidthValue;
    this.data.height = evt.currentHeightValue;
    this.data.top = evt.currentTopValue;
    this.data.left = evt.currentLeftValue;
    this.onResizeSideWindow.emit(this.data);
  }
  public data: any = {};
  
  reqSubcription: Subscription[] = [];
  decryptedParams:any;
  clientKey:any;
  moduleKey:any;
  dashboardKey:any;
  dashboardName:any;

  messages:any = [];

  moment = moment;
  employee_key: any;
  groupByToggle = true;
  insertBtn = false;
  noteValue: any = '';
  jsonDashboard:any = [];
  groupedMessages: any;
  headingIcons = [{"icon": "notes_sorting", "tooltip": "Sort"}, {"icon": "notes_search", "tooltip": "Search"}, {"icon": "expand_circle", "tooltip": "Fullscreen Toggle"}];
  datewiseGroupObj:any = {};
  stateForToggleObj:any = {};
  loadComments = false;
  loadApiModuleByDashboard = false;

  // Pre-computed cached values
  filteredJsonDashboard: any[] = [];
  visibleGroupedMessages: any[] = [];
  private renderBatchSize = 15;
  private allGroupedForRender: any[] = [];
  private renderIndex = 0;
  private isRendering = false;
  error:any;
  editEnabled = false;
  editedEvent:any;
  editIndex:any;
  editedValue:any;
  cardId:any;
  hashTagArray:any = [];

  previousDashboardKey:any;
  currentDashboardKey:any;
  searchChanged = new Subject<string>();
  
  constructor(
    private dialog: MatDialog,
    private router: ActivatedRoute,
    private navigationService: NavigationService,
    private commentsNotesService: CommentsNotesService,
    private filterService: FilterService,
    private dashboardService: DashboardService,
    private enhancementService: EnhancementService,
    private cdr: ChangeDetectorRef,
    private dialogService: DialogService,
    private hashtagService: HashtagService,
    private ngZone: NgZone
  ) {
    this.router.params.subscribe((p: any) => {

      // Query Params
      this.router.queryParams.subscribe((params:any) => {
        this.decryptedParams = this.navigationService.decryptData(params);
        this.clientKey = this.decryptedParams["cl_key"];
        this.moduleKey = this.decryptedParams["md_key"];
        this.dashboardKey = this.decryptedParams["ds_key"]; 
        this.cardId = this.decryptedParams["cardId"];

        this.previousDashboardKey = this.dashboardKey;
        this.currentDashboardKey = this.dashboardKey;

        let desginObj = this.dashboardService.dashboardDetailsOfNotes;
        if(Object.keys(desginObj).length>0) {
          if(desginObj?.dashboardKey) {
            this.dashboardKey = desginObj?.dashboardKey;
          }
        }
      })
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['annotationIndication'].currentValue != changes['annotationIndication'].previousValue) {
      this.loadApiModuleByDashboard = false;
      this.groupByToggle = true;
      this.loadComments = false;
      this.editEnabled = false;
      this.editedEvent = {};
      this.error = '';
      
      let empkey = sessionStorage.getItem('employee_key');
      if (empkey) {
        const parsedEmpkey: any = JSON.parse(empkey);
        this.employee_key = parsedEmpkey._value;
      }

      this.getHashtagData();
      this.getDashboardByModule();
    }
  }

  ngOnInit(): void {
    this.checkOrientation();

    this.searchChanged.pipe(debounceTime(300)).subscribe(v => {
      this.enteredText = v;
      this.onFilterTextBoxChanged(true);
    });
  }

  @HostListener("window:resize", ["$event"])
  onResize(event: Event) {
    this.checkOrientation();
  }

  checkOrientation() {
    this.data.width = 320;
    this.onResizeSideWindow.emit(this.data);
  }

  // ── Cached computation helpers ──

  updateFilteredDashboard() {
    if (!this.jsonDashboard?.length) {
      this.filteredJsonDashboard = [];
    } else {
      this.filteredJsonDashboard = this.jsonDashboard.filter((f: any) => f.notes != 0 || f.dashboard_key == this.dashboardKey);
    }
  }

  /** Pre-compute expensive values on group/message objects so template uses simple property access */
  preComputeGroupData(groups: any[]) {
    if (!groups) return;
    const conversationCountMap: any = {};
    this.messages.forEach((m: any) => {
      conversationCountMap[m.conversation_key] = (conversationCountMap[m.conversation_key] || 0) + 1;
    });

    groups.forEach((group: any) => {
      // Pre-compute hashtags for this group
      group._hashTags = this.findHashTags(group);
      group._noMessages = !group.messages || group.messages.length === 0;

      if (group.messages) {
        group.messages.forEach((msg: any) => {
          msg._initCapName = this.initCap(msg.employee_name);
          msg._htmlComments = this.getMSGHtml(msg.comments);
          msg._expandCount = conversationCountMap[msg.conversation_key] || 0;
        });
      }
    });
  }

  /** Render groups incrementally in batches to avoid blocking the UI */
  renderIncrementally(groups: any[]) {
    this.allGroupedForRender = groups;
    this.renderIndex = 0;
    this.isRendering = true;
    this.visibleGroupedMessages = [];
    this.noVisibleMessages = this.checkAllHaveTheMessages(groups);
    this.renderNextBatch();
  }

  noVisibleMessages = true;

  private renderNextBatch() {
    if (this.renderIndex >= this.allGroupedForRender.length) {
      this.isRendering = false;
      this.cdr.markForCheck();
      return;
    }

    const end = Math.min(this.renderIndex + this.renderBatchSize, this.allGroupedForRender.length);
    const batch = this.allGroupedForRender.slice(this.renderIndex, end);
    this.visibleGroupedMessages = [...this.visibleGroupedMessages, ...batch];
    this.renderIndex = end;
    this.cdr.markForCheck();

    if (this.renderIndex < this.allGroupedForRender.length) {
      this.ngZone.runOutsideAngular(() => {
        requestAnimationFrame(() => {
          this.ngZone.run(() => this.renderNextBatch());
        });
      });
    } else {
      this.isRendering = false;
    }
  }

  /** Called from template scroll event to load more groups */
  onScrollLoadMore(event: any) {
    const el = event.target;
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 100) {
      if (this.isRendering) return;
      if (this.renderIndex < this.allGroupedForRender.length) {
        this.isRendering = true;
        this.renderNextBatch();
      }
    }
  }

  /** Set groupedMessages and trigger pre-computation + incremental render */
  private updateGroupedMessages(groups: any[]) {
    this.groupedMessages = groups;
    this.preComputeGroupData(this.groupedMessages);
    this.renderIncrementally(this.groupedMessages);
  }

  fndZeroNotesJsonDashboard(jsonDashboard:any) {
    if(!jsonDashboard.length) return [];
    return jsonDashboard.filter((f:any)=> f.notes != 0 || f.dashboard_key == this.dashboardKey);
  }
  
  trackPage(i: number, item: any) {
    return item.dashboard_key;
  }

  trackGroup(i: number, group: any) {
    return group.group;
  }

  trackMessage(i: number, msg: any) {
    return msg.user_comments_key;
  }

  isFirstOpen = true;
  pageIdx:any = 0;
  searchvalue = false;
  enteredText:any;
  order:any = 'desc';


  @ViewChild("fs") fs!: ElementRef;
  @HostBinding("class.is-fullscreen") isFullscreen = false;

 
  fullscreenChanges(){
    this.isFullscreen = !this.isFullscreen;
  }

  getHashtagData() {
    // let config = this.currentPatient?.config;
    let obj:any = {
      "brand_key" : this.filterService.baseQuery?.brand_key,
      "hashtag_type": null
    }

    this.reqSubcription.push(
      this.hashtagService.getHashTags(obj).subscribe((res:any)=> {
        this.hashTagArray = res ? res : [];
      })
    )
  }

  loadHashTags(hash:any) {
    this.hashtagService.hashTagQuery.next(hash);
  }

  findHashTags(group:any) {
    let data: any[] = [];
    if (!group.messages || group.messages.length === 0) return data;
    let hashtag_key = group.messages[0].hashtag_key
    
    const normalize = (v: any): string => (v ?? '').toString().replace(/\s+/g, '').toLowerCase();
    let findHash = this.hashTagArray.find((f:any) => normalize(f.hashtag_type + '-' + f.hashtag_key) == normalize(hashtag_key));
    
    if(findHash?.hashtag_value) {
      data = findHash?.hashtag_value.split(',') || []
    } else {
      data = [];
    }

    return data
  }

  remove(hash: string, group:any): void {
    let data = this.findHashTags(group);
    const index = data.indexOf(hash);
    let hashtag_key = group.messages[0].hashtag_key
    if (index >= 0) {
      data.splice(index, 1);
      const normalize = (v: any): string => (v ?? '').toString().replace(/\s+/g, '').toLowerCase();
      let fndHashTag = this.hashTagArray.find((f:any) => normalize(f.hashtag_type + '-' + f.hashtag_key) == normalize(hashtag_key));
      // let fndHashTag = this.hashTagArray.find((f:any)=> f.hashtag_type + " -" + f.hashtag_key == hashtag_key);
      fndHashTag['hashtag_value'] = data.toString();
      let updateKey = fndHashTag?.hash_tag_dtls_key || null;

      this.updateTheHashTags(data.toString(), updateKey)
    }
  }

  updateTheHashTags(hashTag:any, updateKey:any) {
    
    if(updateKey) {
      let postdata: any = { 
        "module_key": this.dashboardService.moduleKey,
        "dashboard_key": this.dashboardKey,
        "brand_key" : this.filterService?.baseQuery?.brand_key,
        "hashtag_value": hashTag,
        "hash_tag_dtls_key": updateKey
      };
  
      this.hashtagService.updateHashTags(postdata).subscribe((res:any)=> {
        this.hashtagService.removeHashtagsGlobal.next(true);
      })
    }
  }

  openExpansionPanel(page:any, pageIdx:any) {
    // debugger
    if(pageIdx==this.pageIdx) return;

    if(this.currentDashboardKey!=page.dashboard_key) {
      let fndData = this.jsonDashboard.find((f:any)=> f.dashboard_key == this.currentDashboardKey);
      if(fndData) {
        fndData.unread_notes = 0;
      }
      this.previousDashboardKey = this.currentDashboardKey;
    }
    this.currentDashboardKey = page.dashboard_key;

    this.pageIdx = pageIdx;
    this.messages = [];
    this.updateGroupedMessages([]);
    this.loadComments = false;
    this.searchvalue = false;
    this.enteredText = "";
    this.order = 'desc';
    this.error = '';
    this.groupByToggle = true;
    this.getCommentsByDashboard(page.dashboard_key);
  }

  onFilterTextBoxChanged(flag?:any) {
    const filterKeys = ["comments", "conversation_key", "employee_name", "updateDate", "insertDate", "hashtags"];
    const messagesToGroup = this.enteredText ? this.filterMessagesByKeys(this.messages, filterKeys, this.enteredText) : this.messages;
    this.updateGroupedMessages(this.groupMessages(messagesToGroup));
    this.searchvalue = flag ? true : false;
  }
  
  /**
   * Filters messages based on specified keys and search text.
   * @param messages - The array of messages to filter.
   * @param filterKeys - The keys to check for the search text.
   * @param searchText - The text to search for.
   * @returns Filtered array of messages.
   */
  filterMessagesByKeys(messages: any[], filterKeys: string[], searchText: string): any[] {
    return messages.filter((obj) => {
      return filterKeys.some((key) => {
        return obj[key] && obj[key].toString().toLowerCase().includes(searchText.toLowerCase());
      });
    });
  }
  
  /**
   * Groups messages based on the toggle state.
   * @param messages - The array of messages to group.
   * @returns Grouped messages.
   */
  groupMessages(messages: any[]): any[] {
    if (this.groupByToggle) {
      return this.groupByConverstion(messages);
    } else {
      return this.commentsNotesService.groupMessagesByOutlookFormat(messages, this.order);
    }
  }

  // Get the All Dashboards By using the Module
  getDashboardByModule() {
    let postdata: any = { "report_typ": "N", "module_key": this.moduleKey};
    this.reqSubcription.push(this.commentsNotesService.notesQuery(postdata).subscribe((res: any) => {

      this.enhancementService.allPageInformation.subscribe((pageInfo: any) => {
          let navbarPage = JSON.parse(sessionStorage.getItem("navbar_page_nm") || '{}');
          let headerNames = pageInfo?.find((o: any) => o.dashboard_key === this.dashboardKey);
          let pageName = headerNames?.dashboard_nm || headerNames?.work_nm || navbarPage.dashboard_nm || navbarPage.work_nm || '';
          this.dashboardName = pageName;
      });

      let jsonDashboard = res ? res : [];
      let fndJson = jsonDashboard.find((f:any)=> f.dashboard_key == this.dashboardKey);
      if(!fndJson) {
        jsonDashboard.push({
          dashboard_key: this.dashboardKey,
          dashboard_nm: this.dashboardName,
          module_key: this.moduleKey,
          notes: 0,
          unread_notes: 0
        })
      }

      this.jsonDashboard = this.commentsNotesService.moveToFirst(jsonDashboard, 'dashboard_key', this.dashboardKey);
      this.updateFilteredDashboard();
      this.cdr.markForCheck();

      setTimeout(() => {
        this.getCommentsByDashboard(this.dashboardKey);
      }, 100);
    }, (err: any) => {
        this.loadApiModuleByDashboard = false;
        console.log(err);
        this.cdr.markForCheck();
    }));
  }

  // Get the Comment/Notes using by dashboardKey
  getCommentsByDashboard(dashboardKey:any) {
    let postdata: any = { 
      "report_typ": "G", // G - Generic
      "dashboard_key": dashboardKey,
      "module_key": this.moduleKey,
      "from_date": "2000-01-01", // moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
      "to_date": moment().format('YYYY-MM-DD'),
      "brand_key" : this.filterService?.baseQuery?.brand_key
    };

    this.reqSubcription.push(this.commentsNotesService.notesQuery(postdata).subscribe((res: any) => {
      this.error = '';
      if(res!=null && res.length>0) {
        this.messages = res;

        this.messages.map((m:any) => { 
          const datePipe = new DatePipe('en-US');
          m.updateDate = m.update_timestamp ? datePipe.transform(new Date(m.update_timestamp), 'MMM d, y, h:mm a') : "";
          m.insertDate = m.insert_timestamp ? datePipe.transform(new Date(m.insert_timestamp), 'MMM d, y, h:mm a') : "";
          return m
        })
        

        // Attaching Hashtags into main messages for search
        this.messages.map((m:any) => { 
          m.hashtags = "";
          
          if(m.hashtag_key) {
            const normalize = (v: any): string => (v ?? '').toString().replace(/\s+/g, '').toLowerCase();
            let fndHashTag = this.hashTagArray.find((f:any) => normalize(f.hashtag_type + '-' + f.hashtag_key) == normalize(m.hashtag_key));
            // let fndHashTag = this.hashTagArray.find((f:any)=> f.hashtag_type + " -" + f.hashtag_key == m.hashtag_key);
            if(fndHashTag?.hashtag_value) {
              fndHashTag?.hashtag_value.split(',').forEach((d:any)=>{
                m.hashtags += d + " ";
              })
            }
          }
          return m
        })

        let desginObj = this.dashboardService.dashboardDetailsOfNotes;
        if(Object.keys(desginObj).length>0) { 
          let fndJson = this.jsonDashboard.find((f:any) => f.dashboard_key == desginObj.dashboardKey && f.dashboard_key == dashboardKey);
          if(fndJson) {

            this.messages = this.messages.filter((f: any) => {

              if (!desginObj?.filterKey) return true;
              if (!this.cardId) return true;
              return f[desginObj.filterKey] == this.cardId;
            });
            fndJson.notes = this.messages.length || 0;
            fndJson.dashboard_nm = desginObj.dashboardName;
          }
        }

        if(this.groupByToggle) {
          this.onFilterTextBoxChanged()
        } else {
          this.updateGroupedMessages(this.commentsNotesService.groupMessagesByOutlookFormat(this.messages, this.order));
        }

      } else {
        this.messages = [];
        this.updateGroupedMessages([]);
      }

      this.unreadLoadApi(dashboardKey);

      this.loadComments = true;
      this.loadApiModuleByDashboard = true;
      this.cdr.markForCheck();
    }, (err: any) => {
      this.error = 'There is an issue...';
      this.messages = [];
      this.updateGroupedMessages([]);
      this.loadComments = false;
      // this.loadApiModuleByDashboard = false;
      console.log(err);
      this.cdr.markForCheck();
    }));
  }

  groupByConverstion(messages:any) {
    const sortedMessages = _.orderBy(messages, [(message:any) => new Date(message.insert_timestamp)], [this.order]);
    const groupedByConversation = _.groupBy(sortedMessages, 'conversation_key');

    return Object.entries(groupedByConversation).map(([key, value]) => ({
      group: key,
      messages: value,
    }));
  }
  
  showAllToggle() {
    this.loadComments = false;
    this.cdr.markForCheck();
    setTimeout(() => {
      this.onFilterTextBoxChanged();
      this.loadComments = true;
      this.cdr.markForCheck();
    });
  }

  findIdxRemove(i:any, idx:any) {

    // Check if the index `i` exists in the data array
    if (this.groupedMessages[i]) {
      let obj = this.groupedMessages[i].messages[idx]
      let fndIndex = this.jsonDashboard.findIndex((f:any)=> f.dashboard_key == obj.dashboard_key);
      if(fndIndex!=-1) {
        this.jsonDashboard[fndIndex].notes -= 1;
      }

      // Use Lodash to remove the element at `idx` in the `message` array
      _.pullAt(this.groupedMessages[i].messages, idx);

      // If the `message` array is empty, remove the main object
      if (_.isEmpty(this.groupedMessages[i].messages)) {
        _.pullAt(this.groupedMessages, i);
      }
    }

    this.noVisibleMessages = this.checkAllHaveTheMessages(this.groupedMessages);
    this.visibleGroupedMessages = [...this.groupedMessages];
    this.allGroupedForRender = this.groupedMessages;
    this.renderIndex = this.groupedMessages.length;
    this.updateFilteredDashboard();
    this.cdr.markForCheck();
  }

  orderBy(order:any, page:any, idx:any) {
    this.order = order; 
    this.onFilterTextBoxChanged();
  }

  fndGroupInclude(name:any, newMessageObj:any) {

    let fndDashboard = this.jsonDashboard.find((f:any)=> f.dashboard_key == this.dashboardKey);
    if(fndDashboard) {
      fndDashboard.notes += 1;
    }

    if(this.currentDashboardKey!=this.dashboardKey) return;
    
    let fndDashboards = this.jsonDashboard.find((f:any)=> f.dashboard_key == this.currentDashboardKey);
    if(fndDashboards) {
      fndDashboards.unread_notes = 0;
    }

    // Set unread_flag = 'N' for all messages in all groupedMessages
    this.groupedMessages.forEach((group: any) => {
      group.messages.forEach((msg: any) => {
          msg.unread_flag = 'N';
      });
    });

    // Find the group by name
    const group = _.find(this.groupedMessages, { group: name });
  
    // Pre-compute on new message
    newMessageObj._initCapName = this.initCap(newMessageObj.employee_name);
    newMessageObj._htmlComments = this.getMSGHtml(newMessageObj.comments);

    if (group) {
      group.messages.unshift(newMessageObj);
      group._hashTags = this.findHashTags(group);
      group._noMessages = false;
    } else {
      const newGroup = {
        group: name,
        messages: [newMessageObj],
        _hashTags: [] as any[],
        _noMessages: false
      };
      newGroup._hashTags = this.findHashTags(newGroup);
      this.groupedMessages.unshift(newGroup);
    }

    // Refresh expand counts
    const conversationCountMap: any = {};
    this.messages.forEach((m: any) => {
      conversationCountMap[m.conversation_key] = (conversationCountMap[m.conversation_key] || 0) + 1;
    });
    this.groupedMessages.forEach((g: any) => {
      g.messages?.forEach((msg: any) => {
        msg._expandCount = conversationCountMap[msg.conversation_key] || 0;
      });
    });

    this.noVisibleMessages = false;
    this.visibleGroupedMessages = [...this.groupedMessages];
    this.allGroupedForRender = this.groupedMessages;
    this.renderIndex = this.groupedMessages.length;
    this.updateFilteredDashboard();
    this.cdr.markForCheck();
  }

  checkAllHaveTheMessages(group:any) {
    if(!group?.length) return true;

    let data = group.find((f:any)=> f.messages.length>0)
    return data ? false : true; 
  }
  
  // Handling Insert
  sendMessage($event: KeyboardEvent | any): void {
    $event.preventDefault();

    if(!this.noteValue) return;

    let postdata: any = { 
      "report_typ": "I",
      "module_key": this.dashboardService.moduleKey,
      "dashboard_key": this.dashboardKey,
      "comments": this.noteValue,
      "brand_key" : this.filterService?.baseQuery?.brand_key
    };

    if(this.notesConfiguration) {
      let config = this.notesConfiguration.config;
      if(config.filterKey) {
        let selectedFilter = this.filterService.selectedItem['single'][config.filterKey];
        postdata["conversation_key"] = [config.prefixConversationKey, selectedFilter[config.conversationKey], config.suffixConversationKey].filter(Boolean).join(' - ');
        postdata[config.payloadKey] = selectedFilter[config.selectKey];
      } else {
        postdata["conversation_key"] = [config.prefixConversationKey, this.cardId, config.suffixConversationKey].filter(Boolean).join(' - ');
        postdata[config.payloadKey] = this.cardId;
      }
      // if(sessionStorage.getItem("source_patient_id")) {
      //   let ab:any = sessionStorage.getItem("source_patient_id");
      //   let json = JSON.parse(ab);
      //   postdata['source_patient_id'] = json.source_patient_id;
      // };
    } else {
      postdata["conversation_key"] = this.dashboardName
    }

    if(sessionStorage.getItem("source_patient_id")) {
      let ab:any = sessionStorage.getItem("source_patient_id");
      let json = JSON.parse(ab);
      postdata['source_patient_id'] = json.source_patient_id;
    };
    

    this.reqSubcription.push(this.commentsNotesService.notesQuery(postdata).subscribe((res: any) => {
      if(res != null && res.length>0) {
        this.noteValue = '';
        let length = res.length-1;
        let obj = res[length]
        this.messages.push(obj);
        this.fndGroupInclude(this.groupByToggle ? obj.conversation_key : 'Today', obj);
        
      }
      this.unreadLoadApi(this.dashboardKey);
    }, (err:any) => {
      this.noteValue = '';
      this.dialogService.customSnackBar('error', 'red', 'Error Message');
      console.log('Issue in Comment Insertion',err)
    }));
  }

  closeCommentBtn() {
    this.insertBtn=!this.insertBtn;
    this.noteValue = '';
    this.editEnabled = false;
    this.editedEvent = {};
  }

  groupedEllipse(comments:any) {
    return comments.length > 30 ? comments.substring(0, 30) + "..." : comments;
  }

  findSubjectWidth(event:any) {
    return (event?._body?.nativeElement?.offsetWidth - 50) || 300
  }

  getMSGHtml(data:any){
    data=data.replaceAll('\n','<br>')
    return data
  }

  saveEdit($event:any, message:any, i:any, idx:any) {
    if(!this.editedValue) return;

    let postdata: any = {
      "report_typ": "U",
      "module_key": this.dashboardService.moduleKey,
      "dashboard_key": this.dashboardKey,
      "comments": this.editedValue,
      "brand_key" : this.filterService?.baseQuery?.brand_key,
      "user_comments_key" : message.user_comments_key
    };

    this.reqSubcription.push(this.commentsNotesService.notesQuery(postdata).subscribe((res: any) => {
      
      const fndIdx = this.messages.findIndex((f:any)=> f.user_comments_key==message.user_comments_key);
      if(fndIdx!=-1) {
        this.messages[fndIdx]['comments'] = postdata.comments;
        this.messages[fndIdx]['update_timestamp'] = new Date();

        this.groupedMessages[i].messages[idx]['comments'] = postdata.comments;
        this.groupedMessages[i].messages[idx]['update_timestamp'] = new Date();
        this.groupedMessages[i].messages[idx]['_htmlComments'] = this.getMSGHtml(postdata.comments);
      }

      this.editedValue = '';
      this.editEnabled = false;
      this.cdr.markForCheck();
    }, (err:any) => {
      this.editedValue = '';
      this.editEnabled = false;
      this.dialogService.customSnackBar('error', 'red', 'Error Message');
      this.cdr.markForCheck();
    }));
  }

  @ViewChild('editTextArea') editTextArea!: ElementRef;
  
  editComment($event:any, message:any, i:any, idx:any) {
    this.editedValue = message.comments;
    this.editIndex = i+'-'+idx
    this.editEnabled = true;

    setTimeout(() => {
      this.editTextArea?.nativeElement.focus();
    }, 0);
  }
  
  deleteComment($event:any, message:any, i:any, idx:any) {
    
    this.editEnabled = false;
    this.insertBtn = false;
    this.noteValue = '';


    let dialogRef = this.dialog.open(PopupDeleteComponent, {
      maxWidth: '90vw',
      disableClose: true,
      hasBackdrop: false,
      panelClass: "du-custom-modalbox",
      data:'comment'
    });

    dialogRef.afterClosed().subscribe((value) => {
      
      if(value == '1') {
        this.deleteCommentApi(message.user_comments_key, i, idx)
      }
    }); 
  }

  deleteCommentApi(key:any, i:any, idx:any) {
    let postdata: any = { 
      "report_typ": "D",
      "user_comments_key": key
    };
    
    this.reqSubcription.push(this.commentsNotesService.notesQuery(postdata).subscribe((res: any) => {

      const fndIdx = this.messages.findIndex((f:any)=> f.user_comments_key==postdata.user_comments_key);
      if(fndIdx!=-1) {
        this.messages.splice(fndIdx, 1);
        this.findIdxRemove(i, idx)
      }

    }, (err:any) => {
      this.dialogService.customSnackBar('error', 'red', 'Error Message');
    }));
  }

  groupTheMessages(data:any) {
    if(data?.length==0) return [];
    return _.orderBy(data, ['insert_timestamp'], ['desc']);
  }
  
  countOfExpands(pageIdx: any, i: any, idx: any) {
    const key = this.groupedMessages?.[i]?.messages?.[idx]?.conversation_key;
    if (!key) return 0;
    return this.messages?.filter((f: any) => f.conversation_key === key)?.length || 0;
  }

  openDialog(pageIdx:any, i:any, idx:any) {
    const key = `group-${pageIdx}-${i}-${idx}`;
    this.datewiseGroupObj[key] = !this.datewiseGroupObj[key];
    
    let dialogRef = this.dialog.open(ExpandThreadComponent, {
      data : {
        key: this.groupedMessages[i].messages[idx]?.conversation_key,
        value: this.messages,
        hashtags: this.hashTagArray,
        dashboardKey: this.dashboardKey
      },
      disableClose: true,
      // width: "100%",
      // height: "90%",
      panelClass: 'du-notes-expand-thread-dialog'
    });
    dialogRef.afterClosed().subscribe((value:any) => {
      if(value["U"]?.length>0) {
        this.modalUpdatedData(value["U"]);
      }
      if(value["D"]?.length>0) {
        this.modalDeletedData(value["D"]);
      }

      if(value.key) {
        const normalize = (v: any): string => (v ?? '').toString().replace(/\s+/g, '').toLowerCase();
        let fndHashTag = this.hashTagArray.find((f:any) => normalize(f.hashtag_type + '-' + f.hashtag_key) == normalize(value?.key));
        // let fndHashTag = this.hashTagArray.find((f:any)=> f.hashtag_type + " - " + f.hashtag_key == value?.key);
        if(fndHashTag) {
          fndHashTag['hashtag_value'] = value?.hash?.toString() || "";
        }
      }
    });
  }
  
  modalDeletedData(data: any) {
    data.forEach((d: any) => {
      this.groupedMessages.forEach((group: any, groupIndex: number) => {
        if (group.messages?.length > 0) {
          const messageIndex = this.messages.findIndex((msg: any) => msg.user_comments_key === d.user_comments_key);
          if (messageIndex !== -1) {
            this.messages.splice(messageIndex, 1);
          }
  
          const groupMessageIndex = group.messages.findIndex((msg: any) => msg.user_comments_key === d.user_comments_key);
          if (groupMessageIndex !== -1) {
            this.findIdxRemove(groupIndex, groupMessageIndex);
          }
        }
      });
    });
  }

  modalUpdatedData(data: any) {
    data.forEach((d: any) => {
      this.groupedMessages.forEach((group: any) => {
        if (group.messages?.length > 0) {
          const messageIndex = this.messages.findIndex((msg: any) => msg.user_comments_key === d.user_comments_key);
          if (messageIndex !== -1) {
            this.messages[messageIndex] = { ...this.messages[messageIndex], ...d };
          }

          const groupMessageIndex = group.messages.findIndex((msg: any) => msg.user_comments_key === d.user_comments_key);
          if (groupMessageIndex !== -1) {
            group.messages[groupMessageIndex] = { ...group.messages[groupMessageIndex], ...d };
            // Re-compute cached values
            group.messages[groupMessageIndex]._initCapName = this.initCap(group.messages[groupMessageIndex].employee_name);
            group.messages[groupMessageIndex]._htmlComments = this.getMSGHtml(group.messages[groupMessageIndex].comments);
          }
        }
      });
    });
    this.cdr.markForCheck();
  }
  
  stateForToggle(pageIdx:any, i:any, idx:any) {
    const key = `toggle-${pageIdx}`;
    this.stateForToggleObj[key] = !this.stateForToggleObj[key];
  }

  unreadLoadApi(dashboardKey:any) {
    let postdata: any = {
      "report_typ": "B",
      "module_key": this.dashboardService.moduleKey,
      "dashboard_key": dashboardKey,
      "comments": this.editedValue,
      "brand_key" : this.filterService?.baseQuery?.brand_key,
    };

    this.reqSubcription.push(this.commentsNotesService.notesQuery(postdata).subscribe((res: any) => {
    }, (err:any) => {
    }));
  }

   
  returnData(pageIdx:any, i:any, idx:any) {
    return `group-${pageIdx}-${i}-${idx}`;
  }
  
  toggleReturnData(pageIdx:any) {
    return `toggle-${pageIdx}`;
  }

  initCap(name:any) {
    return name
      ? name.toLowerCase().replace(/\b\w/g, (c:any) => c.toUpperCase())
      : '';
  }
  
  ngOnDestroy(): void {
    this.reqSubcription.forEach(res => res.unsubscribe())
  }
}
